import React from "react";
import PropTypes from "prop-types";
import AddDeviceRow from "./AddDeviceRow";
import EditDeviceRow from "./EditDeviceRow";
import ViewDeviceRow from "./ViewDeviceRow";

const DeviceRow = (props) => {
  const { mode } = props;
  if (mode === "add") {
    return <AddDeviceRow {...props} />;
  } else if (mode === "edit") {
    return <EditDeviceRow {...props} />;
  } else {
    return <ViewDeviceRow {...props} />;
  }
};

DeviceRow.propTypes = {
  mode: PropTypes.oneOf(["add", "edit", "view"]).isRequired,
  device: PropTypes.object,
  index: PropTypes.number,
  selectedDevice: PropTypes.object,
  onRowClick: PropTypes.func,
  deviceOptions: PropTypes.array,
  addDevice: PropTypes.func,
  handlers: PropTypes.object,
  //handleAutoSave: PropTypes.func,
  newDeviceId: PropTypes.string,
  setNewDeviceId: PropTypes.func,
};

export default DeviceRow;
